var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallAccepted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Call_Accepted"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Call_Accepted",
    "data-name": "Call Accepted",
    clipPath: "url(#clip-Call_Accepted)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call",
    transform: "translate(-2.004 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M49.684,60.964a4.241,4.241,0,0,0-3.134-1.2,4.2,4.2,0,0,0-3,1.467l-3.6,4.317a.876.876,0,0,1-.9.25,15.992,15.992,0,0,1-1.75-.683,32.65,32.65,0,0,1-9.534-6.834,32.219,32.219,0,0,1-6.834-9.534c-.3-.667-.533-1.267-.7-1.767a.877.877,0,0,1,.283-.883L24.8,42.5a4.162,4.162,0,0,0,.267-6.134l-9.8-9.817a4.175,4.175,0,0,0-5.884,0L5.664,30.279a12.412,12.412,0,0,0-3.4,11.334c1.333,6.55,5.084,16.5,15.384,26.8S37.866,82.449,44.434,83.8a12.72,12.72,0,0,0,2.5.25,12.424,12.424,0,0,0,8.834-3.667L59.5,76.665a4.211,4.211,0,0,0,0-5.9Z",
    transform: "translate(0 15.558)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M55.264,2A33.707,33.707,0,0,0,26.9,53.9L21.678,67.138a1.646,1.646,0,0,0,.367,1.783,1.678,1.678,0,0,0,1.183.483,1.537,1.537,0,0,0,.6-.117l13.234-5.217A33.7,33.7,0,1,0,55.264,2Zm0,64.071A30.159,30.159,0,0,1,38.2,60.821a1.76,1.76,0,0,0-.95-.283,1.482,1.482,0,0,0-.6.117L26.178,64.788l4.134-10.467a1.712,1.712,0,0,0-.167-1.55,30.369,30.369,0,1,1,25.119,13.3Z",
    transform: "translate(13.038)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M60.13,14.755a1.66,1.66,0,0,0-2.35,0L45.8,26.739l-6.384-6.384a1.724,1.724,0,0,0-2.35,0l-5.017,5.017a1.68,1.68,0,0,0,0,2.367L44.613,40.307a1.67,1.67,0,0,0,2.35,0L65.147,22.122a1.721,1.721,0,0,0,.483-1.183,1.681,1.681,0,0,0-.483-1.167Z",
    transform: "translate(19.706 8.18)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallAccepted);
export default __webpack_public_path__ + "static/media/call-accepted.a2c04b16116d0df8cb3a638f729c02f7.svg";
export { ForwardRef as ReactComponent };